import Vue from 'vue'
import VueRouter from 'vue-router'
import About from '../views/About.vue'
import Service from '../views/Service.vue'
import Meeting from '../views/Meeting.vue'
import Home from '../views/Home.vue'
import partyItem1 from "../components/party/party_item1.vue";//伯停会
import partyItem2 from "../components/party/party_item2.vue";
import partyItem3 from "../components/party/party_item3.vue";
import partyItem4 from "../components/party/party_item4.vue";
import partyItem5 from "../components/party/party_item5.vue";
import partyItem6 from "../components/party/party_item6.vue";
import partyItem7 from "../components/party/party_item7.vue";
import partyItem8 from "../components/party/party_item8.vue";
import partyItem9 from "../components/party/party_item9.vue";
import partyItem10 from "../components/party/party_item10.vue";
import partyItem11 from "../components/party/party_item11.vue";
import homeItem1 from "../components/home/home_item1.vue";//钱湖伯亭
import homeItem2 from "../components/home/home_item2.vue";
import homeItem3 from "../components/home/home_item3.vue";
import homeItem4 from "../components/home/home_item4.vue";
import photoList from "../components/home/photoList.vue";
import homelist from "../components/home/homeList.vue";//文章详情
import getlist from "../components/party/getList.vue";//文章详情
import fuWuItem1 from "../components/fuwu/fuwu_item1.vue";//五有服务
import fuWuItem2 from "../components/fuwu/fuwu_item2.vue";
import fuWuItem3 from "../components/fuwu/fuwu_item3.vue";
import fuWuItem4 from "../components/fuwu/fuwu_item4.vue";
import fuWuItem5 from "../components/fuwu/fuwu_item5.vue";
import about1 from '../components/about/about_1.vue';//联系我们
import about2 from '../components/about/about_2.vue';//招聘
// import Warning from '../views/Warring.vue'
// import Index from '../views/index.vue'
// import Home from '../views/home.vue'
// import Streetmap from '../components/domestic/streetmap.vue'



Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'Index',
      component: () => import(/* webpackChunkName: "about" */ '../views/Index.vue')
    },
    {
      path:'/Home',
      name:'Home',
     component:Home,
     redirect: '/Home/homeItem1',
     children:[
      {
        path: '/Home/homeItem1',
        component:homeItem1
      }, {
        path: '/Home/homeItem2',
        component:homeItem2
      }, {
        path: '/Home/homeItem3',
        component:homeItem3
      }, {
        path: '/Home/homeItem4',
        component:homeItem4
      }, {
        path: '/Home/homelist',
        component:homelist
      },{
        path: '/Home/photoList',
        component:photoList
      },]
    },
    {
      path:'/Meeting',
      name:'Meeting',
     component:Meeting,
     redirect: '/Meeting/partyItem1',
     children:[
      {
        path: '/Meeting/partyItem1',
        component:partyItem1
      },
      {
        path: '/Meeting/partyItem2',
        component:partyItem2
      },{
        path: '/Meeting/partyItem3',
        component:partyItem3
      },
      {
        path: '/Meeting/partyItem4',
        component:partyItem4
      },{
        path: '/Meeting/partyItem5',
        component:partyItem5
      },{
        path: '/Meeting/partyItem6',
        component:partyItem6
      },{
        path: '/Meeting/partyItem7',
        component:partyItem7
      },{
        path: '/Meeting/partyItem8',
        component:partyItem8
      },{
        path: '/Meeting/partyItem9',
        component:partyItem9
      },{
        path: '/Meeting/partyItem10',
        component:partyItem10
      },{
        path: '/Meeting/partyItem11',
        component:partyItem11
      },
      {
        path: '/Meeting/getlist',
        component:getlist
      },
     ]
    },
    {
      path:'/Service',
      name:'Service',
     component:Service,
     redirect: '/Service/fuWuItem1',
     children: [
      {
        path: '/Service/fuWuItem1',
        component:fuWuItem1
      },
      {
        path: '/Service/fuWuItem2',
        component:fuWuItem2
      },{
        path: '/Service/fuWuItem3',
        component:fuWuItem3
      },
      {
        path: '/Service/fuWuItem4',
        component:fuWuItem4
      },{
        path: '/Service/fuWuItem5',
        component:fuWuItem5
      }
      ]
    },
    {
      path:'/About',
      name:'About',
     component:About,
     redirect: '/About/contact',
     children: [
      {
        path: '/About/contact',
        component:about1
      },
      {
        path: '/About/recruit',
        component:about2
      }]
  
    },
   
    // {
    //   path:'/Streetmap',
    //   name:'Streetmap',
    //   component: NbmaStreetmapp
    // },
  
]
const originalPush = VueRouter.prototype.push
   VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router
